class UnhandledErrorForwarder {
  /**
   * Add event listener, such that unhandled errors can be forwarded using an given `ErrorApi` instance
   */
  static forward(errorApi, errorContext) {
    window.addEventListener(
      "unhandledrejection",
      (e) => {
        errorApi.post(e.reason, errorContext);
      }
    );
  }
}

export { UnhandledErrorForwarder };
//# sourceMappingURL=UnhandledErrorForwarder.esm.js.map
